// Generated by purs version 0.15.15
import * as Data_Coordinates from "../Data.Coordinates/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Restaumatic_Geocoding_Types_StreetAddress from "../Restaumatic.Geocoding.Types.StreetAddress/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Restaumatic_Geocoding_Types_StreetAddress.eqStreetAddress));
var eq1 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Coordinates.eqCoordinates));
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var streetAddressIsSymbol = {
    reflectSymbol: function () {
        return "streetAddress";
    }
};
var ReverseGeocodeResponseIsSymbol = {
    reflectSymbol: function () {
        return "ReverseGeocodeResponse";
    }
};
var decodeRecord1 = /* #__PURE__ */ Unscramble.decodeRecord1();
var coordinatesIsSymbol = {
    reflectSymbol: function () {
        return "coordinates";
    }
};
var GeocodeResponseIsSymbol = {
    reflectSymbol: function () {
        return "GeocodeResponse";
    }
};
var encodeWithOptionsRecord = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord();
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil);
var decodeWithOptionsRecord = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord();
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil);
var ReverseGeocodeResponse = function (x) {
    return x;
};
var GeocodeResponse = function (x) {
    return x;
};
var toFillFormTypeReverseGeoc = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var toFillFormTypeGeocodeResp = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var newtypeReverseGeocodeResp = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeGeocodeResponse_ = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldReverseGeocodeRes = function (dictHasField) {
    return dictHasField;
};
var hasFieldGeocodeResponse = function (dictHasField) {
    return dictHasField;
};
var eqReverseGeocodeResponse = {
    eq: function (x) {
        return function (y) {
            return eq(x.streetAddress)(y.streetAddress);
        };
    }
};
var eqGeocodeResponse = {
    eq: function (x) {
        return function (y) {
            return eq1(x.coordinates)(y.coordinates);
        };
    }
};
var genericReverseGeocodeResponse = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showReverseGeocodeResponse = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericReverseGeocodeResponse)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(streetAddressIsSymbol)(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Geocoding_Types_StreetAddress.showStreetAddress)))))(ReverseGeocodeResponseIsSymbol))
};
var unscrambleDecodeReverseGeocodeResponse = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericReverseGeocodeResponse)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ decodeRecord1(/* #__PURE__ */ Unscramble.decodeRecordCons(streetAddressIsSymbol)(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Geocoding_Types_StreetAddress.unscrambleDecodeStreetAddress))(Unscramble.decodeRecordNil)))))(Unscramble_Generic.defaultOptions)
};
var genericGeocodeResponse = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showGeocodeResponse = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericGeocodeResponse)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(coordinatesIsSymbol)(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Coordinates.showCoordinates)))))(GeocodeResponseIsSymbol))
};
var unscrambleDecodeGeocodeResponse = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericGeocodeResponse)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ decodeRecord1(/* #__PURE__ */ Unscramble.decodeRecordCons(coordinatesIsSymbol)(/* #__PURE__ */ Unscramble.decodeMaybe(Data_Coordinates.unscrambleDecodeCoordinates))(Unscramble.decodeRecordNil)))))(Unscramble_Generic.defaultOptions)
};
var encodeReverseGeocodeResponse = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericReverseGeocodeResponse)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ReverseGeocodeResponseIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons(streetAddressIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Geocoding_Types_StreetAddress.encodeStreetAddress)))))))
};
var encodeGeocodeResponse = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericGeocodeResponse)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(GeocodeResponseIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons(coordinatesIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Data_Coordinates.encodeCoordinates)))))))
};
var decodeReverseGeocodeResponse = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericReverseGeocodeResponse)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ReverseGeocodeResponseIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons(streetAddressIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Geocoding_Types_StreetAddress.decodeStreetAddress)))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodeGeocodeResponse = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericGeocodeResponse)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(GeocodeResponseIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons(coordinatesIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Data_Coordinates.decodeCoordinates)))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    ReverseGeocodeResponse,
    GeocodeResponse,
    genericReverseGeocodeResponse,
    eqReverseGeocodeResponse,
    showReverseGeocodeResponse,
    encodeReverseGeocodeResponse,
    decodeReverseGeocodeResponse,
    unscrambleDecodeReverseGeocodeResponse,
    toFillFormTypeReverseGeoc,
    hasFieldReverseGeocodeRes,
    newtypeReverseGeocodeResp,
    genericGeocodeResponse,
    eqGeocodeResponse,
    showGeocodeResponse,
    encodeGeocodeResponse,
    decodeGeocodeResponse,
    unscrambleDecodeGeocodeResponse,
    toFillFormTypeGeocodeResp,
    hasFieldGeocodeResponse,
    newtypeGeocodeResponse_
};
